import React, { useEffect } from "react";

function Dashhudson(props) {
  useEffect(() => {
    setTimeout(function() {
      // Create a script element
      var script = document.createElement('script');
      var dashhudsonContainer = document.getElementById('dashhudson');
      // Set script attributes
      script.src = "https://cdn.dashhudson.com/web/js/board-carousel-embed.js";
      script.type = "text/javascript";
      script.async = true;
      script.setAttribute("data-name", "dhboard-carousel");
      script.setAttribute("data-gallery-id", props.data_gallery_id);
      script.setAttribute("data-row-size", props.data_row_size? props.data_row_size:"4");
      script.setAttribute("data-gap-size", props.data_gap_size? props.data_gap_size:"4");
      script.setAttribute("data-mobile-row-size", props.data_mobile_row_size? props.data_mobile_row_size:"2");
      script.setAttribute("data-autoplay", props.data_autoplay? props.data_autoplay:"true");
      script.setAttribute("data-mobile-gap-size", props.data_mobile_gap_size? props.data_mobile_gap_size:"2");
      if(props.data_call_to_action){
        script.setAttribute("data-call-to-action", props.data_call_to_action);
      }
  
      // Append the script element to the document body
      dashhudsonContainer.appendChild(script);
      //added a delay in the function as dashhudson doesn't load with dom and is shown at bottom
     }, 2000); // 2000 milliseconds = 2 seconds
  

  },[])
  
  return (
    <>
    <div id="dashhudson"></div>
    </>
  );
}

export default Dashhudson;
